import React from 'react';
import { BRAND, CLOSING_LINE, CLOSING_SUB, costRows } from '../data/eatWellContent';
export function CostSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="cost-title" data-id="element-36" data-mp="9d9anmxuss9z">
      <div className="mx-auto max-w-3xl px-5" data-id="element-37" data-mp="4jwvs4iz7zuf">
        <h2 id="cost-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-38" data-mp="3vriurjur3e4y">
          What not having it costs
        </h2>

        <div className="mt-8 flex items-baseline justify-between gap-4 text-[9px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-39" data-mp="3mqkzpr2aigyi">
          <span data-id="element-40" data-mp="3hs9mr7gp7qc2">Without {BRAND}</span>
          <span data-id="element-41" data-mp="3csn3ohe6vfvc">Real cost</span>
        </div>

        <ul className="mt-2 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-42" data-mp="3ctyeh161xnvy">
          {costRows.map(row => <li key={row.situation} className="flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6" data-id="element-43" data-mp="1fyafcx6p5t4n">
              <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory-100" data-id="element-44" data-mp="p6s7u0pbnq7u">
                {row.situation}
              </span>
              <span className="text-[14px] leading-snug text-rose sm:shrink-0 sm:text-right" data-id="element-45" data-mp="f9nftk8sp0j4">
                → {row.result}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-xl italic text-ivory-50 sm:text-2xl" data-id="element-46" data-mp="17y2ug5o0lgtx">
          {CLOSING_LINE}
        </p>
        <p className="mt-1 text-center font-display text-xl italic text-champagne sm:text-2xl" data-id="element-47" data-mp="1cxfhaqevynwi">
          {CLOSING_SUB}
        </p>
      </div>
    </section>;
}